import { isDealLabel } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import { Deal, Points, PointsAndLabelsWrapper } from "./styles";
import { useProduct } from "../../hooks/internal";
import { jsx as _jsx } from "react/jsx-runtime";
export var PointsOrDealLabel = function PointsOrDealLabel() {
  var _labels$deal;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useProduct = useProduct(),
    code = _useProduct.code,
    hasEnoughPoints = _useProduct.hasEnoughPoints,
    labels = _useProduct.labels,
    productPoints = _useProduct.productPoints;
  if (productPoints !== undefined) {
    return /*#__PURE__*/_jsx(PointsAndLabelsWrapper, {
      children: /*#__PURE__*/_jsx(Points, {
        hasEnoughPoints: hasEnoughPoints,
        "data-testid": "".concat(getTestId('points'), "-").concat(code),
        children: productPoints
      })
    });
  }
  var _ref = (_labels$deal = labels === null || labels === void 0 ? void 0 : labels.deal) !== null && _labels$deal !== void 0 ? _labels$deal : {},
    _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? null : _ref$labelKey,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title;
  if (isDealLabel(labelKey) && title) {
    return /*#__PURE__*/_jsx(PointsAndLabelsWrapper, {
      children: /*#__PURE__*/_jsx(Deal, {
        offerLabelSmallerOnMobile: true,
        label: title,
        type: labelKey,
        productCode: code
      })
    });
  }
  return null;
};
//# sourceMappingURL=PointsOrDealLabel.js.map